export { default } from './WinnerCard';
